<template>
    <v-container class="d-flex flex-row justify-center" style="transform: scale(0.97);">
        <v-alert :border="($vuetify.breakpoint.mdAndDown) ? '' : 'left'"
            :width="($vuetify.breakpoint.mdAndDown) ? '100%' : '450px'" colored-border color="primary"
            class="rounded-lg" :elevation="($vuetify.breakpoint.mdAndDown) ? '0' : '7'">
            <v-row class="d-flex flex-column justify-center align-center">
                <v-img :src="selectedImage" contain max-width="75px" />
                <div class="font-weight-bold primary--text text-subtitle-1 ">{{ title }}</div>
                <div v-if="subtitle !== ''" class="font-weight-bold primary--text text-subtitle-2 ">{{ subtitle }}</div>
            </v-row>
            <v-card-text class="d-flex flex-row">
                <v-row v-if="!simple">
                    <v-col cols="6" md="6" class="d-flex justify-center">
                        <v-list>
                            <v-list-item v-for="(item, index) in items.slice(0, 3)" :key="index" class="espacio-lista">
                                <v-list-item-title class="contenido d-flex flex-row align-center">
                                    <div class="font-weight-regular text-body-2">
                                        <v-icon color="primary">mdi-circle-medium</v-icon>
                                        {{ item }}
                                    </div>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col cols="6" md="6" class="d-flex justify-center">
                        <v-list>
                            <v-list-item v-for="(item, index) in items.slice(3, 6)" :key="index" class="espacio-lista">
                                <v-list-item-title class="contenido d-flex flex-row align-center">
                                    <div class="font-weight-normal text-body-2">
                                        <v-icon color="primary">mdi-circle-medium</v-icon>
                                        {{ item }}
                                    </div>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-row v-if="simple" class="d-flex justify-center align-center">
                <v-list>
                    <v-list-item class="espacio-lista" v-for="(item, index) in items" :key="index">
                        <v-list-item-title class="contenido d-flex flex-row align-center">
                            <v-icon color="primary">
                                mdi-circle-medium
                            </v-icon>
                            <div class="font-weight-regular text-body-2">
                                {{ item }}
                            </div>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-row>
        </v-alert>
    </v-container>
</template>

<script>
import imgPersoneles from '@/assets/afiliacion/img-datos-personales.png'
import imgConyuge from '@/assets/afiliacion/img-datos-conyuge.png'
import imgContacto from '@/assets/afiliacion/img-datos-contacto.png'
import imgProfesionales from '@/assets/afiliacion/img-datos-profesionales.png'
import imgDocumentacion from '@/assets/afiliacion/img-documantacion-digitalizada.png'

export default {
    props: {
        tipo: {
            type: String,
            required: true
        },
        simple: {
            type: Boolean
        }
    },
    data() {
        return {
            items: [],
            title: '',
            subtitle: '',
        };
    },
    computed: {
        selectedImage() {
            switch (this.tipo) {
                case 'personales':
                    return imgPersoneles;
                case 'conyuge':
                    return imgConyuge;
                case 'contacto':
                    return imgContacto;
                case 'profesionales':
                    return imgProfesionales;
                case 'documentacion':
                    return imgDocumentacion;
                default:
                    return '';
            }
        }
    },
    mounted() {
        this.updateItemsAndTitle();
    },
    watch: {
        tipo() {
            this.updateItemsAndTitle();
        }
    },
    methods: {
        updateItemsAndTitle() {
            switch (this.tipo) {
                case 'personales':
                    this.title = 'DATOS PERSONALES';
                    this.items = ['Nombre y apellido', 'DNI', 'CUIL', 'Fecha de nacimiento', 'Nacionalidad', 'Estado civil'];
                    this.subtitle = '';
                    break;
                case 'conyuge':
                    this.title = 'DATOS DEL CÓNYUGE O CONVIVIENTE';
                    this.subtitle = '(si corresponde)';
                    this.items = ['Nombre y apellido', 'DNI', 'CUIL', 'Fecha de nacimiento', 'Nacionalidad'];
                    break;
                case 'contacto':
                    this.title = 'DATOS DE CONTACTO';
                    this.items = ['Domicilios', 'Teléfonos', 'Correo electrónico'];
                    this.subtitle = '';
                    break;
                case 'profesionales':
                    this.title = 'TUS DATOS PROFESIONALES';
                    this.items = ['Nro. de matrícula', 'Fecha de matriculación', 'Fecha de título'];
                    this.subtitle = '';
                    break;
                case 'documentacion':
                    this.title = 'DOCUMENTACIÓN DIGITALIZADA';
                    this.items = ['DNI de afiliado y conviviente/cónyuge (frente y dorso)', 'DNI del conviviente o cónyuge (frente y dorso)', 'Acta o partida de matrimonio/convivencia', 'Título profesional (frente y dorso)', 'Historial de matrícula expedido por el colegio de psicólogos (si corresponde)', 'Certificado laboral (si corresponde)'];
                    this.subtitle = '';
                    break;
                default:
                    this.title = '';
                    this.items = [];
                    this.subtitle = '';
            }
        }
    }
}
</script>

<style>
.limit {
    word-wrap: break-word;
}

.espacio-lista {
    margin: 0 0 0 0;
    padding: 0 0 0 0;
}

.contenido {
    word-break: keep-all;
    text-wrap: wrap;
    margin: 5px 0;
}
</style>